import { useNavigate } from "react-router-dom";
import { List, Search, Globe2 } from "lucide-react";
import { PageHeader } from "../components/common";
import PopularAirlines from "../components/PopularAirlines";
import SEOHead from "../components/SEOHead";
import { breadcrumbLd } from "../lib/structuredData";

export default function Airlines() {
  const nav = useNavigate();

  const submit = (e) => {
    e.preventDefault();
    const q = new FormData(e.target).get("q")?.trim();
    nav(q ? `/airlines/directory?q=${encodeURIComponent(q)}` : "/airlines/directory");
  };

  return (
    <div data-testid="airlines-page">
      <SEOHead
        title="Airlines — Full Profiles, Routes & Loyalty Programs"
        description="Browse 6,000+ airlines worldwide. Every carrier links to its routes, fleet, hubs, loyalty programs and traveler discussion."
        canonical="/airlines"
        jsonLd={breadcrumbLd([["Home", "/"], ["Airlines"]])}
      />
      <PageHeader eyebrow="Directory" title="Airlines"
        subtitle="The most popular carriers in the US, Europe and worldwide — every airline links to its full profile, discussion board and complaint form." />
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="flex flex-col sm:flex-row gap-3 mb-8">
          <form onSubmit={submit} className="flex flex-1 gap-2">
            <input name="q" data-testid="airlines-search"
              placeholder="Search 6,000+ airlines by name or IATA/ICAO code…"
              className="flex-1 border border-zinc-300 bg-white px-4 py-3 outline-none focus:ring-2 focus:ring-primary transition-colors" />
            <button type="submit" data-testid="airlines-search-submit"
              className="inline-flex items-center gap-1.5 px-5 py-3 text-sm font-700 bg-primary text-white hover:bg-blue-700 transition-colors">
              <Search className="w-4 h-4" /> Search
            </button>
          </form>
          <button onClick={() => nav("/airlines/directory")} data-testid="browse-directory-btn"
            className="inline-flex items-center justify-center gap-1.5 px-5 py-3 text-sm font-700 border border-zinc-300 bg-white text-zinc-700 hover:border-primary hover:text-primary transition-colors">
            <List className="w-4 h-4" /> All Airlines A–Z
          </button>
          <button onClick={() => nav("/airlines/ranking")} data-testid="global-ranking-btn"
            className="inline-flex items-center justify-center gap-1.5 px-5 py-3 text-sm font-700 border border-zinc-300 bg-white text-zinc-700 hover:border-primary hover:text-primary transition-colors">
            <Globe2 className="w-4 h-4" /> Global Ranking
          </button>
        </div>
        <PopularAirlines />
      </div>
    </div>
  );
}
